import type { ShotView, StoryboardView } from "@dramapie/shared";

import { SHOT_STATUS_META } from "../../lib/status";

export interface ShotStripProps {
  view: StoryboardView | null;
  activeShotId: string | null;
  onSelect: (shotId: string) => void;
}

const LEGEND = [
  { tone: "approved", label: "已确认" },
  { tone: "review", label: "待复核" },
  { tone: "pending", label: "待生成" },
  { tone: "error", label: "失败" },
] as const;

/**
 * 镜头带（56px）：一格一镜，颜色 = 状态，点一下滚动定位并选中该镜。
 * 每个色块都是 `<button>` 且带 `aria-label`（镜号 + 状态），键盘可达。
 */
export function ShotStrip({ view, activeShotId, onSelect }: ShotStripProps) {
  const shots: ShotView[] = [...(view?.shots ?? [])].sort((a, b) => a.order - b.order);

  return (
    <div className="dp-strip">
      <span className="dp-strip-label">镜头带 · {shots.length}</span>
      {shots.length === 0 ? (
        <span className="dp-strip-empty" style={{ flex: 1 }}>
          本集还没有镜头
        </span>
      ) : (
        <div className="dp-ticks">
          {shots.map((shot) => {
            const meta = SHOT_STATUS_META[shot.status];
            return (
              <button
                key={shot.id}
                type="button"
                className={`dp-tick is-${meta.tone}`}
                aria-label={`第 ${shot.order} 镜 · ${meta.label}`}
                aria-pressed={shot.id === activeShotId}
                title={`第 ${shot.order} 镜 · ${meta.label}`}
                onClick={() => onSelect(shot.id)}
              />
            );
          })}
        </div>
      )}
      <div className="dp-strip-legend" aria-hidden="true">
        {LEGEND.map((item) => (
          <span key={item.tone}>
            <i className={`is-${item.tone}`} />
            {item.label}
          </span>
        ))}
      </div>
    </div>
  );
}
